import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import DataAction from '../../data/actions';
import Utils from '../../utils';
import AppsUtils from '../utils';
import withUserInfo from '../../core/EcrionProvider/boot/withUserInfo';
var CONSTANTS = {
  INSTALLED: 'InstalledOk',
  INSTALLING: 'Installing',
  UNINSTALLED: 'OTHER, TODO'
};
/**
 * @param {import('./types').InstalledProps} props
 */

var IsInstalled = function IsInstalled(_ref) {
  var uninstalled = _ref.uninstalled,
      installed = _ref.installed,
      installing = _ref.installing,
      retry = _ref.retry,
      loading = _ref.loading,
      app = _ref.app,
      userInfo = _ref.userInfo;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var _React$useState3 = React.useState(true),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isLoading = _React$useState4[0],
      setLoading = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      reloadFlag = _React$useState6[0],
      setReloadFlag = _React$useState6[1];

  var unmounted = React.useRef(false);
  React.useEffect(function () {
    unmounted.current = false; // setLoading(true);//only first loading for now

    DataAction.item({
      dataType: 'microservice',
      id: app
    }).refresh().then(function (_ref2) {
      var payload = _ref2.payload;
      if (unmounted.current) return;
      var newState = payload.MicroserviceAppInstallation.Instalation.Status;
      setState(newState);
      setLoading(false);

      if (newState === CONSTANTS.INSTALLING) {
        setTimeout(function () {
          if (unmounted.current) return;
          if (!retry) return;
          setReloadFlag(function (r) {
            return !r;
          });
        }, 3000);
      }
    }).catch(function () {
      if (unmounted.current) return;
      setState(CONSTANTS.UNINSTALLED);
      setLoading(false);
      setTimeout(function () {
        if (unmounted.current) return;
        if (!retry) return;
        setReloadFlag(function (r) {
          return !r;
        });
      }, 3000);
    });
    return function () {
      unmounted.current = true;
    };
  }, [reloadFlag, retry]);

  var createArgument = function createArgument() {
    return {
      installUrl: AppsUtils.redirect('Home', "/app/".concat(app, "/getstarted?environment"))
    };
  };

  var render = function render(cb) {
    if (!cb) return null;
    if (typeof cb === 'function') return cb(createArgument());
    return cb;
  };

  if (isLoading) return render(loading);
  if (state === CONSTANTS.INSTALLED) return render(installed);
  if (state === CONSTANTS.INSTALLING) return render(installing);
  return render(uninstalled);
};

IsInstalled.defaultProps = {
  loading: null,
  installed: null,
  uninstalled: null,
  installing: null,
  retry: false
};
export default withUserInfo(IsInstalled);